import styleInject from 'style-inject';
import { collectStyles } from '@lsg/ssr';

var reactStyles = " .lsgs-MS4xNC4w--navigation-link-group{display:flex;flex-wrap:wrap;flex-direction:row;list-style-image:none;list-style-type:none;padding:0;margin:24px -8px;}.lsgs-MS4xNC4w--navigation-link-group-centered-layout{justify-content:center;margin:0 0 24px 0;}@media screen and (min-width:1024px){.lsgs-MS4xNC4w--navigation-link-group-centered-layout{margin:24px 0;}}";
var hostClass = "lsgs-MS4xNC4w--navigation-link-group";
styleInject(reactStyles);
collectStyles(reactStyles);

export { hostClass, reactStyles };
